module.exports = "/_next/static/images/EnableDataDrivenDecisionMaking-0850c81fda0c75c0427cbbc888aefa7a.webp";